import { FC, memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./suggest-for-your-ads.module.css";
import { FakeAdsProductsResponse } from "../../entities/user-statistics.response";
import { fetchUserStatistics } from "../../services/ads.services";
import { useAppSearchParams } from "@commons-monorepo/index";
import { UiButton } from "@ui-monorepo/index";

interface SuggestForYourAdsProps {
  token?: string;
  scope?: string;
}

const SuggestForYourAds: FC<SuggestForYourAdsProps> = ({ token, scope }) => {
  const { t } = useTranslation();
  const [products, setProducts] = useState<FakeAdsProductsResponse>([]);
  const [isCollapse, setIsCollapse] = useState(false);
  const [params] = useAppSearchParams();
  const paramToken = token || params.get("ads_user_token");
  const paramScope = scope || params.get("feature_scope");
  const isInAdsWebview = paramScope === "ads";

  useEffect(() => {
    if (isInAdsWebview && paramToken) {
      fetchUserStatistics(paramToken).
      then((r) => setProducts(r)).
      catch((r) => setProducts(r));
    }
  }, [params]);

  return isInAdsWebview && !!products.length ?
  <div className={styles.suggestForYourAdsWrapper}>
      <div
      className={`${styles.collapsibleBox} ${isCollapse && styles.collapse}`}>

        <div
        className={styles.collapsibleBoxHeader}
        onClick={() => setIsCollapse((s) => !s)}>

          <div className={styles.adsIcon}>
            <span className='icon-megaphone' />
          </div>
          <p className={styles.adsText}>
            {t("ads_suggestions.collapsible_text")}
          </p>
          <span className={`${styles.iconArrow} icon-arrow`} />
        </div>
        <div className={styles.collapsibleBoxContent}>
          <ul className={styles.bestAdsProductsList}>
            {products.map((i) =>
          <li
            key={`suggest-for-your-adds-product-card-${i.id}`}
            className={styles.productCard}>

                <figure className={styles.imageFigure}>
                  <img
                src={i.images[0]}
                alt={`Product`}
                className={styles.img} />

                </figure>
                <div className={styles.productCardTexts}>
                  <div className={styles.lastMonthClickCount}>
                    <span className={styles.text}>
                      {t("ads_suggestions.product_card_text")}
                    </span>
                  </div>
                  <div className={styles.productName}>{i.name}</div>
                </div>
              </li>
          )}
          </ul>
          <div className={styles.callToActionBox}>
            <div className={styles.boxTexts}>
              <div className={styles.greenCircleIcon}>
                <span className='icon-chart-line-up' />
              </div>
              <div className={styles.texts}>
                <div className={styles.textsTitle}>
                  {t("ads_suggestions.cta_title")}
                </div>
                <div className={styles.textsDescription}>
                  {t("ads_suggestions.cta_description")}
                </div>
              </div>
            </div>
            <UiButton
            onClick={() => {
              window.MessageInvoker?.postMessage("");
            }}>

              {t("ads_suggestions.cta_button")}
            </UiButton>
          </div>
        </div>
      </div>
    </div> :
  null;
};

export default memo(SuggestForYourAds);